module.exports = __webpack_public_path__ + "img/gw-alb.035ed5f5.png";